import React, { useEffect, useState, useRef } from "react";
import Header from "../Section/Header";
import {
  CalendarDays,
  MapPin,
  Sunrise,
  Sunset,
  Clock4,
  LayoutList,
  Hourglass,
} from "lucide-react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Footer from "../Section/Footer";
import {
  get_timezone_data,
  panchang,
  sendKundliData,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import Loader from "../Section/Loader";
import hourglass from "../../Assests/hourglass.png";

export default function ShubhMahurat() {
  // To load on first mount
  const [selectedDate, setSelectedDate] = useState(() => {
    const saved = localStorage.getItem("savedDate");
    return saved ? new Date(saved) : new Date();
  });

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [location, setLocation] = useState(() => {
    return (
      localStorage.getItem("savedLocation") || "Bhopal, Madhya Pradesh,India"
    );
  });

  const [currentTime, setCurrentTime] = useState(new Date());
  const [latitude, setLatitude] = useState("23.2599333");
  const [longitude, setLongitude] = useState("77.412615");
  const [TimeZone, setTimezone] = useState(() => {
    return localStorage.getItem("savedTimezone") || "Asia/Kolkata";
  });
  const [userHasEditedLocation, setUserHasEditedLocation] = useState(false);
  const [userHasEditedDate, setUserHasEditedDate] = useState(false);
  const [Responsessss, setResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const inputRef = useRef(null);
  const isSaveDisabled = location.trim() === "";

  const splitPlace = (placeString) => {
    if (!placeString) return { city: "", state: "", country: "" };
    const parts = placeString.split(",").map((part) => part.trim());
    return {
      city: parts[0] || "",
      state: parts[1] || "",
      country: parts[2] || "",
    };
  };

  useEffect(() => {
  const saved = localStorage.getItem("savedDate");
  if (saved) {
    setSelectedDate(new Date(saved));
    setUserHasEditedDate(true);
  }
}, []);


  const handleDateChange = (date) => {
    if (!date || !dayjs(date).isValid()) return;

    const jsDate = date.toDate();
    setSelectedDate(jsDate);
    localStorage.setItem("savedDate", jsDate.toISOString());
    setUserHasEditedDate(true); // 👈 mark user has picked date
    fetchTimeZone(latitude, longitude, location);
  };

  const handleSaveLocation = () => {
    setIsEditing(false);
    setUserHasEditedLocation(true); // ✅ Mark user edited
    localStorage.setItem("savedLocation", location);
    fetchTimeZone(latitude, longitude, location);
  };



  const fetchTimeZone = async (latitude, longitude, locationData) => {
    const formData = new FormData();
    try {
      formData.append("latitude", latitude);
      formData.append("longitude", longitude);
      const response = await server_post_data(get_timezone_data, formData);
      const data = response.split("~@~");
      if (parseInt(data[0]) === 1) {
        console.error("Timezone API Error:", data[1]);
        return;
      }

      const final_data = JSON.parse(data[1]);
      const timezoneName = final_data[0]["timezone_name"];
      setTimezone(timezoneName);
      localStorage.setItem("savedTimezone", timezoneName);
      const { city, state, country } = splitPlace(locationData);
      fetchAstroData(city, state, country, timezoneName);
    } catch (error) {
      console.error("Error in fetchTimeZone:", error);
    }
  };

  const parseDDMMYYYYToDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const fetchAstroData = async (city, state, country, timeZoneId) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("date", selectedDate.toLocaleDateString("en-GB"));
    formData.append("city", city);
    formData.append("state", state);
    formData.append("country", country);
    formData.append("latitude", formattedLatLong(latitude));
    formData.append("longitude", formattedLatLong(longitude));
    formData.append("timeZoneId", timeZoneId);

    try {
      const response = await sendKundliData(panchang, formData);
      console.log("🌓 Astro Response:", response);
      setIsLoading(false);
      setResponse(response);

      if (response) {
        if (!userHasEditedLocation) {
          const fullLocation = `${response.city}, ${response.state}, ${response.country}`;
          setLocation(fullLocation);
        }
        if (!userHasEditedDate) {
          setSelectedDate(parseDDMMYYYYToDate(response.date));
        }
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const formattedLatLong = (originalValue) => {
    const multipliedValue = originalValue * 100;
    const roundedValue = Math.floor(multipliedValue);
    return roundedValue / 100;
  };

  useEffect(() => {
    const savedTimezone = localStorage.getItem("savedTimezone");
    const { city, state, country } = splitPlace(location);

    if (!savedTimezone) {
      fetchTimeZone(latitude, longitude, `${city}, ${state}, ${country}`);
    } else {
      fetchAstroData(city, state, country, savedTimezone); // use cached one
    }
  }, []);

  useEffect(() => {
    if (!isEditing || !window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["(cities)"],
        // componentRestrictions: { country: "in" },
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      setLocation(place.formatted_address || place.name);
      setUserHasEditedLocation(true);

      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setLatitude(lat);
        setLongitude(lng);
      } else {
        console.warn("⚠️ No geometry found for selected place.");
      }
    });
  }, [isEditing]);

  const getKaalIcon = (value) => {
    const positiveValues = ["Shubha", "Labha", "Amrita"];
    const negativeValues = ["Kala", "Roga", "Udvega"];
    const neutralValues = ["Chal"];

    if (positiveValues.includes(value)) {
      return require("../../Assests/worship.png");
    } else if (negativeValues.includes(value)) {
      return require("../../Assests/thunder.png");
    } else if (neutralValues.includes(value)) {
      return require("../../Assests/line.png");
    }
    return null;
  };

  // Define color mapping for KaalDataValue
  const colorMapping = {
    Amrita: "#557A10",
    Shubha: "#839626",
    Labha: "#839626",
    Chal: "#505050",
    Roga: "#B23813",
    Kala: "#B23813",
    Udvega: "#B23813",
  };

  const getEllipseColor = (item) => {
    const keyword = item.second_data; // Use second_data as it contains the keyword
    return colorMapping[keyword] || "#505050"; // Default color if not found
  };

  return (
    <>
      <Header />
      {isLoading && <Loader />}
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow py-10 px-4">
        <div className="max-w-[1050px] mx-auto relative">
          <div className="text-center mb-8">
            <h2 className="text-[25px] md:text-[32px] lg:text-[37px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
              📿 Shubha Muhurat Consultation
            </h2>
            <p className="text-[16px] md:text-lg text-purple-200 mt-2">
              Find the most auspicious dates and times for your important life
              events with expert astrological guidance.
            </p>
          </div>
          {/* IMPROVED Location and Date Selector - More Compact & Readable */}
          <div className="rounded-xl shadow-lg bg-slate-800/70 backdrop-blur-sm p-4 mb-6 border border-slate-700/50">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              {/* Location Section - Improved Layout */}
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <MapPin className="w-5 h-5 text-[#c0a1e6] flex-shrink-0" />
                <div className="relative flex items-center">
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <input
                      type="text"
                      ref={inputRef}
                      value={location}
                      readOnly={!isEditing}
                      onChange={(e) => setLocation(e.target.value)}
                      className="font-semibold text-white text-[17px] Custum_Input_location_box md:min-w-[240px]
    bg-transparent outline-none border-b transition-colors duration-300
    border-pink-400"
                      onClick={() => !isEditing && setIsEditing(true)}
                    />

                    {isEditing && (
                      <button
                        onClick={handleSaveLocation}
                        disabled={isSaveDisabled}
                        className={`px-4 py-2 text-sm font-medium rounded-lg text-white transition-all flex-shrink-0
                      ${
                        isSaveDisabled
                          ? "bg-gray-600 opacity-50 cursor-not-allowed"
                          : "bg-pink-600 hover:bg-pink-700 active:scale-95 shadow-md hover:shadow-lg"
                      }`}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
                {!isEditing && (
                  <p
                    className="hidden md:block text-xs text-white/40 mt-1 italic group-hover:text-white/70"
                    onClick={() => !isEditing && setIsEditing(true)}
                  >
                    Click to edit location
                  </p>
                )}
              </div>

              {/* Date Section - Improved Layout */}
              <div className="flex items-center gap-3 flex-shrink-0 cusm_date_picker_container">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="DD/MM/YYYY"
                    value={dayjs(selectedDate)}
                    onChange={handleDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        placeholder: "Select your birth date",
                        variant: "outlined",
                        className: "custom-datepicker",
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>

          {/* {showDatePicker && (
            <div className="absolute top-[10.5rem] right-[-0.1rem] z-50">
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                inline
              />
            </div>
          )} */}

          <div className="mt-[2rem] rounded-xl shadow-lg bg-slate-800/70 backdrop-blur-sm p-3 mb-6 border border-slate-700/50">
            {/* TITLE ABOVE BOX */}
            <div className="flex flex-col items-center mb-4">
              <div className="text-orange-400 text-[22px] font-semibold flex items-center gap-2">
                <Clock4 className="w-4 h-4" />
                Aaj ka Choghadiya
              </div>
            </div>

            {/* CHOGHADIYA BOX */}
            <div className="rounded-xl shadow-md bg-slate-800/60 backdrop-blur-sm pddinghCls md:px-[5rem] py-3  text-white">
              <div className="flex md:flex-row flex-col items-center justify-between gap-4">
                {/* LEFT SECTION */}
                <div className="flex-1 flex flex-col itemCenter md:items-left  gap-[5px]">
                  <div className="text-[16px] text-white/70 mb-1">
                    {selectedDate.toLocaleDateString("en-GB")} –{" "}
                    {Responsessss.city}
                  </div>
                  <div className="text-[16px] text-white/70 mb-1">
                    {Responsessss.CurrentWeekday}
                  </div>
                  <div className="text-xs text-white/50 mb-2">
                    Current Time: {Responsessss.currentTime}
                  </div>
                </div>

                {/* DIVIDER WITH LUCIDE HOURGLASS */}
                <div className="flex-1 flex flex-col items-center justify-center px-3">
                  <div className="w-px h-10 bg-white/30"></div>

                  <img
                    src={hourglass}
                    alt="Kaal Icon"
                    className="text-white/40 my-1 w-10 h-10 " // Tailwind example, or use your CSS
                  />

                  <div className="w-px h-10 bg-white/30"></div>
                </div>

                {/* RIGHT SECTION */}
                <div className="flex-1 flex flex-col justify-center items-center gap-[10px] text-right">
                  <label className="text-[16px]  custom_label">
                    <span>
                      {getKaalIcon(Responsessss.KaalDataValue) && (
                        <img
                          src={getKaalIcon(Responsessss.KaalDataValue)}
                          alt="Kaal Icon"
                          className="w-6 h-6 object-contain" // Tailwind example, or use your CSS
                        />
                      )}
                    </span>
                    <span className="w-10">{"    "}</span>
                    {Responsessss.KaalDataValue}
                  </label>
                  <div className="text-xs text-white/50 mb-2">
                    {Responsessss.timeSlotValue}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Tables */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10">
            <div className="bg-white border border-white/10 p-3 rounded-xl shadow-md w-full overflow-x-auto">
              <div className="border-b border-white-500/20 flex justify-between items-center pb-3 mb-4">
                <div className="flex flex-col">
                  <h3 className="flex items-center gap-2 text-[16px] font-semibold text-black-300">
                    <Sunrise className="w-4 h-4" /> Day Choghadiya
                  </h3>
                  <p className="mt-[3px] text-black-300 text-[13px] pl-6">
                    {" "}
                    {selectedDate.toLocaleDateString("en-GB")} ({" "}
                    {Responsessss.city} )
                  </p>
                </div>
                <span className="text-black-300 text-[14px]">
                  Sunset:{" "}
                  {Responsessss.recvBirthDetails2 &&
                    Responsessss.recvBirthDetails2[1].second_data}
                </span>
              </div>

              <div className="space-y-0">
                {Responsessss.dayChoghadiyaRecyclerView &&
                  Responsessss.dayChoghadiyaRecyclerView.map((item, index) => (
                    <div
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-slate-800/40" : "bg-slate-800/20"
                      } hover:bg-black-900/30 hover:text-white  transition-all duration-200 border-b border-white/10 p-3   flex justify-between items-center`}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill={getEllipseColor(item)}
                      >
                        <circle cx="12" cy="12" r="10" />
                      </svg>
                      <span
                        className="font-medium"
                        style={{ color: getEllipseColor(item) }}
                      >
                        {item.second_data}
                      </span>
                      {item.current_show === "1" && (
                        <img
                          src={hourglass}
                          alt="Kaal Icon"
                          className="text-white/40 my-1 w-8 h-8 " // Tailwind example, or use your CSS
                        />
                      )}
                      <span className="text-black-200 text-sm">
                        {item.name_for} - {item.time_word}
                      </span>{" "}
                    </div>
                  ))}
              </div>
            </div>
            <div className="bg-white border border-white/10 p-3 rounded-xl shadow-md w-full overflow-x-auto">
              <div className="border-b border-black-500/20 flex justify-between items-center pb-3 mb-4">
                <div className="flex flex-col">
                  <h3 className="flex items-center justify-center gap-2 text-[16px] font-semibold text-black-300">
                    <Sunset className="w-4 h-4" /> Night Choghadiya
                  </h3>
                  <p className="mt-[3px] text-black-300 text-[13px] pl-6">
                    {" "}
                    {selectedDate.toLocaleDateString("en-GB")} ({" "}
                    {Responsessss.city} )
                  </p>
                </div>

                <span className="text-black-300 text-[14px]">
                  Sunset:{" "}
                  {Responsessss.recvBirthDetails2 &&
                    Responsessss.recvBirthDetails2[1].second_data}
                </span>
              </div>

              <div className="space-y-0">
                {Responsessss.nightChoghadiyaRecyclerView &&
                  Responsessss.nightChoghadiyaRecyclerView.map(
                    (item, index) => (
                      <div
                        key={index}
                        className={`${
                          index % 2 === 0
                            ? "bg-slate-800/40"
                            : "bg-slate-800/20"
                        } hover:bg-black-900/30 hover:text-white  transition-all duration-200 border-b border-white/10 p-3   flex justify-between items-center`}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill={getEllipseColor(item)}
                        >
                          <circle cx="12" cy="12" r="10" />
                        </svg>
                        <span
                          className="font-medium"
                          style={{ color: getEllipseColor(item) }}
                        >
                          {item.second_data}
                        </span>
                        {item.current_show === "1" && (
                          <img
                            src={hourglass}
                            alt="Kaal Icon"
                            className="text-white/40 my-1 w-8 h-8 " // Tailwind example, or use your CSS
                          />
                        )}
                        <span className="text-black-200 text-sm">
                          {item.name_for} - {item.time_word}
                        </span>{" "}
                      </div>
                    )
                  )}
              </div>
            </div>

            <div className="lg:col-span-2 bg-white border border-black/10 p-6 rounded-xl shadow-md w-full  overflow-x-auto">
              <h3 className="flex items-center gap-2 text-[16px] font-semibold text-black-300 mb-4 border-b border-black-500/20 pb-2">
                <LayoutList className="w-4 h-4" /> Hindu Panchang
              </h3>
              <div className="w-full text-sm text-left text-black border-collapse min-w-[400px] overflow-x-auto">
                {Responsessss.recvBirthDetails &&
                  Responsessss.recvBirthDetails.map((item, index) => (
                    <div
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-slate-800/40" : "bg-slate-800/20"
                      } hover:bg-black-900/30 hover:text-black transition-all duration-200 border-b border-black/10 p-3 flex justify-between items-center`}
                    >
                      <span className="w-1/3 font-medium text-black-200">
                        {item.name_for}
                      </span>
                      <span className="w-1/3 text-black-200 text-sm text-center">
                        {item.time_word}
                      </span>
                      <span className="w-1/3 text-black-200 text-sm text-right">
                        {item.second_data}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
